import { createMuiTheme } from '@material-ui/core/styles'

const fontFamily = "'Proxima Nova Regular', sans-serif"
const fontFamilyBold = "'Proxima Nova Bold', sans-serif"
const fontFamilyRegular = "'Proxima Nova Regular', sans-serif"

const fontWeightBold = 700
const fontWeightMedium = 500
const fontWeightRegular = 400

const spacingUnit = 8
export const sizing = {
  unit: spacingUnit,
  xxl: spacingUnit * 10, // 80
  xl: spacingUnit * 6, // 48
  lg: spacingUnit * 4, // 32
  md: spacingUnit * 2, // 16
  sm: spacingUnit, // 8
  xs: spacingUnit / 2, // 4
}

export const palette = {
  black: '#000000',
  background: '#252525',
  yellow: '#f7d666',
  white: '#ffffff',
  lightGrey: '#878787',
  brandGold: '#b28d42',
  green: '#19231a',
  lightGreen: '#007156',
  primary: {
    main: '#b28d42',
  },
}

const transition =
  '250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'

const theme = createMuiTheme({
  palette,
  sizing,
  typography: {
    useNextVariants: true,
  },
  weights: {
    fontWeightBold,
    fontWeightMedium,
    fontWeightRegular,
  },
  status: {
    danger: 'orange',
  },
  props: {
    MuiWithWidth: {
      initialWidth: 'xs',
    },
  },
  transition,
})

// We can only use typography function such as pxToRem after the createMuiTheme
theme.typography = {
  ...theme.typography,
  fontFamily,
  fontFamilyBold,
  fontFamilyRegular,
  fontFamilySecondary: fontFamily,
  h1: {
    ...theme.typography.h1,
    fontWeight: fontWeightMedium,
    fontSize: theme.typography.pxToRem(40),
    lineHeight: theme.typography.pxToRem(54),
  },
  h2: {
    ...theme.typography.h2,
    fontWeight: fontWeightRegular,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(43),
  },
  h3: {
    ...theme.typography.h3,
    fontWeight: fontWeightMedium,
    fontSize: theme.typography.pxToRem(24),
    lineHeight: theme.typography.pxToRem(32),
  },
  h4: {
    ...theme.typography.h4,
    fontWeight: fontWeightRegular,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(24),
  },
  h5: {
    ...theme.typography.h5,
    fontWeight: fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
  },
  h6: {
    ...theme.typography.h6,
    fontWeight: fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
  },
  subtitle1: {
    ...theme.typography.subtitle1,
  },
  subtitle2: {
    ...theme.typography.subtitle2,
  },
  body1: {
    ...theme.typography.body1,
    fontWeight: fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
  },
  body2: {
    ...theme.typography.body2,
  },
  button: {
    ...theme.typography.button,
    fontWeight: fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
  },
  caption: {
    ...theme.typography.caption,
    fontWeight: fontWeightRegular,
    fontSize: theme.typography.pxToRem(11),
    lineHeight: theme.typography.pxToRem(16),
  },
  overline: {
    ...theme.typography.overline,
  },
}

// Overrides are assigned here so we can use theme.breakpoints
// Override cake ui components here based off classes api
theme.overrides = {}

export default theme
